export const TotalBillDiscount = (pricingRule, setCart, cart, orderType, cartObj, iscoupon, couponInput, uniqReferenceId, mPricingCouponId, mPricingRulesId) => {
  console.log("cartObj", cartObj);

  const isExchange = localStorage.getItem("selectedReturnType") === "EXCHANGE";

  const saleTypeValidation = pricingRule.cwrSaletypeId === null ? true : pricingRule.cwrSaletypeId === orderType.cwrSaletype.cwrSaletypeId;

  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;

  const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData")) || {};

  let taxIncludeFlag = saleTypeData?.customer?.istaxincluded === "Y" ? "Y" : tillData.tillAccess.csBunit.isTaxIncluded || "Y";

  const billCart = { ...cartObj };

  let nonReturnItemsTotal = 0;
  let nonReturnItemsQty = 0;
  let nonReturnItemsDiscount = 0;
  let nonReturnItems = [];

  billCart.items.forEach((item) => {
    if (!item.isReturn) {
      nonReturnItemsTotal += item.nettotal;
      nonReturnItemsQty += item.weight;
      nonReturnItemsDiscount += item.discount;
      nonReturnItems.push(item);
    }
  });

  const minQtyFlag = pricingRule.minimumQty ? Math.abs(nonReturnItemsQty) >= pricingRule.minimumQty : true;

  const maxQtyFlag = pricingRule.maximumQty ? Math.abs(nonReturnItemsQty) <= pricingRule.maximumQty : true;

  const minAmountFlag = pricingRule.billAmount ? Math.abs(nonReturnItemsTotal) >= pricingRule.billAmount : true;

  const maxAmountFlag = pricingRule.maxBillAmount ? Math.abs(nonReturnItemsTotal) <= pricingRule.maxBillAmount : true;

  let giftCardFlag = false;

  nonReturnItems.forEach((item) => {
    if (item.isGiftCard) giftCardFlag = true;
  });

  // let totalBillPrice = nonReturnItems.reduce((sum, p) => sum + p.realPrice * Math.abs(p.weight), 0);
  const hasApplicableProducts = Array.isArray(pricingRule?.applicableProducts) && pricingRule.applicableProducts.length > 0;

  let totalBillPrice = nonReturnItems
    .filter((item) => (hasApplicableProducts ? pricingRule.applicableProducts.some((p) => p?._id === item?.productId) : true))
    .reduce((sum, p) => sum + p.realPrice * Math.abs(p.weight), 0);

  let discountFlag = false; // 🔥 FIX: GLOBAL FLAG

  if (
    Math.abs(nonReturnItemsTotal) + Math.abs(nonReturnItemsDiscount) >= pricingRule.billAmount &&
    minQtyFlag &&
    maxQtyFlag &&
    minAmountFlag &&
    maxAmountFlag &&
    totalBillPrice >= pricingRule.billAmount &&
    !giftCardFlag
  ) {
    let discountType = pricingRule.discountType === "V" ? "FD" : "PD";

    billCart.items.forEach((item, index) => {
      let excludingFlag = true;
      const hasApplicableProducts = Array.isArray(pricingRule?.applicableProducts) && pricingRule.applicableProducts.length > 0;

      const isEligibleProduct = hasApplicableProducts ? pricingRule.applicableProducts.some((p) => p?._id === item?.productId) : true;

      if (!isEligibleProduct) {
        return;
      }
      if (!item.isReturn && saleTypeValidation && excludingFlag) {
        let discountAmt, sp;

        // if (discountType === "FD") {
        //   discountAmt = (totalBillPrice - pricingRule.amountDiscount) * ((item.realPrice * item.weight) / totalBillPrice);

        //   item.discount = item.realPrice * item.weight - discountAmt;

        //   sp = (item.realPrice * item.weight - item.discount) / item.weight;
        // }
        if (discountType === "FD") {
          const itemTotal = Number(item.realPrice || 0) * Number(item.weight || 0);

          discountAmt = totalBillPrice > 0 ? (Number(pricingRule.amountDiscount || 0) * itemTotal) / totalBillPrice : 0;

          item.discount = Math.min(discountAmt, itemTotal);

          sp = Number(item.weight || 0) > 0 ? (itemTotal - item.discount) / Number(item.weight) : 0;
        } else {
          discountAmt = (pricingRule.percentageDiscount / 100) * item.realPrice;

          item.discount = discountAmt * item.weight;
          sp = item.realPrice - discountAmt;
        }

        discountFlag = true;

        const mrp = sp * item.weight;

        const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + item.taxRate / 100) : (mrp * item.taxRate) / 100;

        item.salePrice = sp;
        item.taxAmount = tax;
        item.nettotal = taxIncludeFlag === "Y" ? mrp : mrp + tax;

        item.discountName = pricingRule.printedName;
        item.mPricingruleId = pricingRule.mPricingrulesId;
        item.iscoupon = iscoupon;
        item.referenceId = uniqReferenceId;
        item.mPricingCouponId = mPricingCouponId;
        item.priority = pricingRule.priority;

        billCart.items[index] = item;
      }
    });

    // ===============================
    // 🔥 FIXED COUPON LOGIC (FINAL)
    // ===============================

    let couponsData = cartObj?.couponInput ? [...cartObj.couponInput] : [];

    const couponCode = typeof couponInput === "object" ? couponInput?.couponCode : couponInput;

    if (couponCode && discountFlag && !couponsData.some((c) => c.couponCode === couponCode)) {
      couponsData.push({
        couponCode,
        referenceId: uniqReferenceId,
        mPricingCouponId,
        mPricingruleId: pricingRule.mPricingrulesId,
      });
    }

    // ===============================

    let totalTax = 0;
    let totalPrice = 0;
    let totalQty = 0;
    let totalDiscount = 0;

    billCart.items.forEach((i, idx) => {
      totalPrice += i.nettotal;
      totalTax += i.taxAmount;
      totalQty += i.weight;
      totalDiscount += i.discount;
      i.key = idx;
    });

    // ✅ Apply max discount cap globally
    if (pricingRule?.maxDiscount && totalDiscount > pricingRule?.maxDiscount) {
      // Adjust proportionally across items
      let reductionRatio = pricingRule.maxDiscount / totalDiscount;

      // billCart.items.forEach((item) => {
      //   item.discount = item.discount * reductionRatio;

      //   // Recalculate values after adjustment
      //   const mrp = item.salePrice * item.weight;
      //   const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + item.taxRate / 100) : (mrp * item.taxRate) / 100;

      //   item.taxAmount = tax;
      //   item.nettotal = taxIncludeFlag === "Y" ? mrp : mrp + tax;
      // });
      billCart.items.forEach((item) => {
        item.discount = Number(item.discount || 0) * reductionRatio;

        const itemTotal = Number(item.realPrice || 0) * Number(item.weight || 0);

        const discountedTotal = itemTotal - Number(item.discount || 0);

        const updatedSalePrice = Number(item.weight || 0) > 0 ? discountedTotal / Number(item.weight) : 0;

        const tax = taxIncludeFlag === "Y" ? discountedTotal - discountedTotal / (1 + item.taxRate / 100) : (discountedTotal * item.taxRate) / 100;

        item.salePrice = updatedSalePrice;
        item.taxAmount = tax;

        item.nettotal = taxIncludeFlag === "Y" ? discountedTotal : discountedTotal + tax;
      });

      totalDiscount = pricingRule.maxDiscount;
      totalTax = 0;
      totalPrice = 0;

      billCart.items.forEach((item) => {
        totalPrice += Number(item.nettotal || 0);
        totalTax += Number(item.taxAmount || 0);
      });
    }

    const roundOffValue = Math.round(totalPrice);
    const totalRoundOff = totalPrice - roundOffValue;

    const tcsValue = cartObj?.tcs || 0;

    const obj = {
      ...cartObj,
      items: [...billCart.items],
      total: totalPrice + tcsValue,
      tax: totalTax,
      subTotal: parseFloat((totalPrice - totalTax).toFixed(precision)),
      discount: totalDiscount,
      totalQty: totalQty,
      roundOff: totalRoundOff,
      iscoupon: !!iscoupon,
      couponInput: couponsData,
      totalBillDicount: iscoupon ? pricingRule.mPricingrulesId : false,
      totalDiscountFlag: true,
      saleType: JSON.parse(localStorage.getItem("saleTypeData"))?.cwrSaletype || {},
    };

    if (isExchange) {
      localStorage.setItem("exchangeCartObj", JSON.stringify(obj));
    } else {
      localStorage.setItem("cartObj", JSON.stringify(obj));
    }

    if (!iscoupon && !isExchange) {
      setCart(obj);
    }

    return obj;
  }

  // ===============================
  // ❌ FALLBACK (NO DISCOUNT)
  // ===============================

  let couponsData = cartObj?.couponInput ? [...cartObj.couponInput] : [];

  const couponCode = typeof couponInput === "object" ? couponInput?.couponCode : couponInput;

  if (couponCode && !couponsData.some((c) => c.couponCode === couponCode)) {
    couponsData.push({
      couponCode,
      referenceId: uniqReferenceId,
      mPricingCouponId,
      mPricingruleId: pricingRule.mPricingrulesId,
    });
  }

  const obj = {
    ...cartObj,
    couponInput: couponsData,
  };

  return obj;
};
